import css from 'styled-jsx/css';

export default css`.ghost_banner {
  height: 100%;
  display: flex;
  justify-content: center;
  cursor: pointer; }
  .ghost_banner img {
    height: 100%; }
`